export default "__VITE_ASSET__37454ce4__"